module.exports = __webpack_public_path__ + "img/arrow-up.f5dd67b8.svg";